module.exports = __webpack_public_path__ + "static/media/delete.fdec646d.svg";